import { ComponentProps } from 'react';

import { ContentBox } from './styles';

type ContentBoxProps = ComponentProps<typeof ContentBox>;

export const ContentBoxComponent = (props: ContentBoxProps) => (
  <ContentBox {...props} />
);
